import { isValidGUID } from './general';
import { getBasename, getExtname } from '../platformAbstraction/pathComposition';

export const parseMimirIdFromFilePath = (filePath: string, pathSeparator: string) => {
  if (!filePath) {
    return;
  }

  const start = filePath.lastIndexOf(pathSeparator) + 1;
  const end = start + 36;
  const longEnough = end <= filePath.length;
  if (!longEnough) {
    return;
  }

  // should have "." (highres) or "-" (proxy, segmented media etc.) after the GUID
  const suffixRecognized = filePath.startsWith('.', end) || filePath.startsWith('-', end);
  if (!suffixRecognized) {
    return;
  }

  const possibleMimirId = filePath.substring(start, end);
  if (!isValidGUID(possibleMimirId)) {
    return;
  }

  return possibleMimirId;
};
export function pathExtension(sep: string, path: string) {
  const pos = path.lastIndexOf('.');
  if (pos < 1) {
    return '';
  }
  if (path.indexOf(sep, pos - 1) != -1) {
    return '';
  }
  return path.substr(pos);
}

export function truncateFileName(fileName: string, maxCharacters: number | null, itemId: string, pathSep: string) {
  if (!maxCharacters || fileName.length <= maxCharacters) return fileName;

  let baseFileName = getBasename(fileName, pathSep);
  const ext = getExtname(fileName, pathSep);
  const itemIdIndex = baseFileName.indexOf(itemId);
  if (itemIdIndex > -1) {
    baseFileName = `${baseFileName.substring(0, itemIdIndex)}${itemId.replace(/-/g, '')}${baseFileName.substring(itemIdIndex + itemId.length)}`;
  }
  return `${baseFileName.substring(0, maxCharacters - ext.length).trim()}${ext}`;
}
